const getDisplayDate = (date: string) => {
  const dateObj = new Date(date);

  if (Number.isNaN(dateObj.getDate())) {
    return '';
  }

  return `${
    dateObj.getMonth() + 1
  }/${dateObj.getDate()}/${dateObj.getFullYear()}`;
};

export default getDisplayDate;
